import { render, staticRenderFns } from "./MinhaPaginaHeader.vue?vue&type=template&id=5f572b1e&scoped=true&"
import script from "./MinhaPaginaHeader.vue?vue&type=script&lang=js&"
export * from "./MinhaPaginaHeader.vue?vue&type=script&lang=js&"
import style0 from "./MinhaPaginaHeader.vue?vue&type=style&index=0&id=5f572b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f572b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
